<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Agenzia Noleggio' : 'Nuova Agenzia Noleggio' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-rental-agency-form [data]="data"></app-rental-agency-form>
</div>
